import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <path
        fill="none"
        stroke="black"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M260.219 299.34c-24.396 1.773-45.604-16.573-47.372-40.968-1.634-22.537 13.973-42.149 35.578-46.435l67.28-107.971a8.048 8.048 0 0 1 9.945-2.738c3.538 1.598 5.426 5.511 4.488 9.282l-35.042 122.371c3.329 5.674 5.581 12.079 6.09 19.083 1.769 24.396-16.572 45.603-40.967 47.376z"></path>
      <path
        fill="none"
        stroke="black"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M256.04 55.758c-110.198 0-199.522 89.324-199.522 199.517s89.324 199.518 199.522 199.518c110.188 0 199.512-89.325 199.512-199.518S366.228 55.758 256.04 55.758z"></path>
      <path
        fill="none"
        stroke="black"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M280.555 96.8s-112.317-21.094-170.167 90.457"></path>
      <path
        fill="black"
        stroke="black"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M405.694 255.654H357.36M154.572 255.654h-48.334M256.759 144.23v-23.861M364.24 148.154l-24.274 23.191M183.628 328.309l-34.177 34.178M362.618 362.089l-34.177-34.177M183.842 183.925l-22.755-22.755"></path>
    </svg>
  );
};

export default Icon;
